import { render, staticRenderFns } from "./StackChart.vue?vue&type=template&id=2a708e2c"
import script from "./StackChart.vue?vue&type=script&lang=js"
export * from "./StackChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports